import templateStr from 'text!./templates/gateway-documents.html';
import DocumentUtil from 'edge/gateway/util/DocumentUtil';

import _ from 'underscore';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            documents: '=',
            documentMetadataTemplate: '=',
            associatedEntityName: '@'
        },

        controller: ['UserService', '$scope', 'httpSettings', '$window', 'ModalService', '$stateParams', 'DocumentService', '$q', '$filter', 'PolicyService', function (UserService, $scope, httpSettings, $window, ModalService, $stateParams, DocumentService, $q, $filter, PolicyService) {
            var permissionDTO = {
                permission: 'doccreate'
            };
            $scope.allDocs = 0;
            $scope.allDocs = PolicyService.getDocumentsForPolicy($stateParams.policyNumber);
            $scope.allDocs.then(function (data) {
                var finalData = [];
                var test = "a";
                angular.forEach(data, function (res) {
                    /*                    if (res.documentBlob != null || res.documentBlob !== undefined) {
                                            const _url = covertBlobToURL(res.documentBlob);
                                            res.documentURL = _url.replace('unsafe:', '');
                                        }*/
                    finalData.push(res);
                });
                $scope.fullDocumentsData = finalData;
                $scope.documents = finalData;
                $scope.filteredDocuments = finalData;
                if (data.length === 0) {
                    $scope.documentsEmpty = true;
                }
            }, function (error) {
                $scope.err_code = error.baseError.error.code;
                $scope.policydocumentsEmpty = true;
            });

            function covertBlobToURL(blobData) {
                var binary = DocumentUtil.decode(blobData);
                var len = binary.length;
                var view = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i);
                }
                // Create Base64 Object
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    // do nothing because fileUrl generation is not supported in IE
                } else {
                    // for Chrome Firefox etc
                    var file = new Blob([view], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    return fileURL;
                }
            }

            /**
             * More Link for QA and DEV server
             * Prod has to be added in portal/config.js once it is available
             */
            $scope.msfHost = PolicyService.getMsfPortalHost();
            $scope.msfHost.then(function (data) {
                $scope.moreLink = data + '/Edo';
            }, function (err) {
                console.error('Error while retrieving MSF host: ', err);
            });
            $scope.documentsLink = function () {
                PolicyService.callEUTS('Policy Details', 'View more documents Link', $stateParams.policyNumber);
            };
            // function to get document blob and open in frontend for individual data
            $scope.openURL = function (url) {

                PolicyService.getDocumentsByFileId($stateParams.policyNumber, url.documentBlob).then(function (data) {
                    angular.forEach(data, function (fileData) {
                        // Create Base64 Object
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            // for IE
                            var binary = DocumentUtil.decode(fileData.documentBlob);
                            var len = binary.length;
                            var view = new Uint8Array(len);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }
                            if (url.fileName === undefined) {
                                // for IE
                                url.fileName = 'Document';
                            }
                            window.navigator.msSaveOrOpenBlob(new Blob([view], { type: 'application/pdf' }), url.fileName); // Entering document click information in EUTS for analytics purpose
                            // Entering document click information in EUTS for analytics purpose
                            PolicyService.callEUTS('Documents', url.documentBlob + url.fileName, $stateParams.policyNumber, 'Download Selected Documents');
                        } else {
                            // for Chrome Firefox etc
                            if (fileData.documentBlob != null && fileData.documentBlob !== undefined) {
                                var _url = covertBlobToURL(fileData.documentBlob);
                                $window.open(_url);
                                // Entering document click information in EUTS for analytics purpose
                                PolicyService.callEUTS('Documents', url.documentBlob + url.fileName, $stateParams.policyNumber, 'Download Selected Documents');
                            }
                        }
                    });
                }, function () {});
            };
            var permissionCheckPromise = UserService.hasUserSystemPermission(permissionDTO);

            permissionCheckPromise.then(function (showEditContact) {
                $scope.showUploadButton = showEditContact;
            });

            $scope.alerts = [];
            $scope.documentQuery = '';
            $scope.xCenterDownloadURI = httpSettings.serviceBaseURLs.pc + 'document/gateway/document';
            $scope.documentNotFoundURL = $window.location.pathname.substring(0, location.pathname.lastIndexOf('/')) + '/GatewayDocumentError';
            $scope.filteredDocuments = $scope.documents;
            $scope.recentlyAddedIDs = [];
            $scope.metadataTemplate = $scope.documentMetadataTemplate;
            $scope.allDocs = 0;

            $scope.$watchCollection('documents', function (newValue, oldValue) {

                if (newValue && newValue !== oldValue) {
                    $scope.filteredDocuments = $scope.documents;
                    $scope.$emit('documentsUpdated', $scope.documents);
                }
            });

            $scope.$watch('dataTemplate', function () {
                $scope.metadataTemplate = $scope.documentMetadataTemplate;
            });
            $scope.$watch('documentQuery', function () {
                $scope.applyFilter();
            });

            $scope.isRecentlyAdded = function (id) {
                return _.contains($scope.recentlyAddedIDs, id);
            };

            $scope.$on('fileuploaddone', function (e, data) {
                $scope.recentlyAddedIDs.push(data.result.result.publicID);
            });

            $scope.$on('fileuploadstart', function () {
                $scope.recentlyAddedIDs = [];
            });
            $scope.applyFilter = function () {
                if ($scope.documentQuery !== undefined && $scope.documentQuery !== '') {
                    $scope.filteredDocuments = $filter('filter')($scope.documents, {
                        fileName: $scope.documentQuery
                    });
                } else {
                    $scope.filteredDocuments = $scope.fullDocumentsData;
                }
            };
            $scope.closeAlert = function (index) {
                $scope.alerts.splice(index, 1);
            };

            $scope.pageSize = 20;
            $scope.queryOptions = {
                offsetStart: 0,
                offsetEnd: $scope.pageSize - 1
            };

            function getDocsCurrentUser() {
                if ($scope.allDocs === 0) {
                    $scope.allDocs = PolicyService.getDocumentsForPolicy($stateParams.policyNumber);
                }
                return $scope.allDocs;
            }

            function updateDocumentData() {

                return getDocsCurrentUser().then(function (data) {
                    var finalData = [];
                    angular.forEach(data, function (res) {
                        /*                            if (res.documentBlob != null || res.documentBlob !== undefined) {
                                                        const _url = covertBlobToURL(res.documentBlob);
                                                        res.documentURL = _url;
                                                    }*/
                        finalData.push(res);
                    });
                    $scope.fullDocumentsData = finalData;
                    $scope.filteredJobs = $filter('orderBy')(finalData, 'deliveryDate').reverse();

                    $scope.allJobData = $scope.filteredJobs.slice($scope.queryOptions.offsetStart, $scope.queryOptions.offsetEnd + 1);

                    return {
                        'items': $scope.allJobData,
                        'maxNumberOfResults': finalData.length
                    };
                }, function (error) {
                    $scope.jobsLoading = false;
                    $scope.err_code = error.baseError.error.code;
                    $scope.policydocumentsEmpty = true;
                });
            }

            $scope.tableTitle = 'Documents '; // Empty title since title is already available
            $scope.loadingComplete = true;
            var _getLoadByOffset = _.memoize(function () {
                return function (offsetStart, offsetEnd) {
                    $scope.queryOptions.offsetStart = offsetStart;
                    $scope.queryOptions.offsetEnd = offsetEnd;
                    return updateDocumentData();
                };
            });

            $scope.getLoadByOffset = function () {

                return _getLoadByOffset();
            };

            $scope.removeDocument = function (document) {
                if (!document.canDelete) {
                    // only add an alert if there is not already one added

                    if (!_.findWhere($scope.alerts, {
                        documentName: document.name
                    })) {
                        var alertMsg = $filter('translate')('gateway.directives.GatewayDocuments.Unable to delete document', {
                            documentName: document.name
                        });

                        $scope.alerts.push({
                            type: 'info',
                            msg: alertMsg,
                            documentName: document.name
                        });
                    }
                    return;
                }

                var title = $filter('translate')('gateway.directives.GatewayDocuments.Remove Document');
                var msg = $filter('translate')('gateway.directives.GatewayDocuments.Are you sure you want to remove', {
                    documentName: document.name
                });

                ModalService.showWarning(title, msg, null, $filter('translate')('gateway.directives.GatewayDocuments.Yes'), null, $filter('translate')('gateway.directives.GatewayDocuments.No')).result.then(function () {
                    $q.when(DocumentService.removeDocument(document.publicID), function (deleted) {
                        if (deleted === true) {
                            for (var i = 0; i < $scope.documents.length; i++) {
                                if (document.publicID === $scope.documents[i].publicID) {
                                    $scope.documents.splice(i, 1);
                                }
                            }
                        } else {
                            ModalService.showWarning('gateway.directives.GatewayDocuments.Document deletion may have failed', 'gateway.directives.GatewayDocuments.Something may have gone wrong trying to delete your document.');
                        }
                    }, function () {
                        ModalService.showError('gateway.directives.GatewayDocuments.Document deletion failed', 'gateway.directives.GatewayDocuments.Sorry your document could not be deleted at this time');
                    });
                });
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/GatewayDocuments.js
// module id = 1745
// module chunks = 0